<template>
  <div class="row mb-1">
    <div
      id="gender"
      class="col-md-12 px-gap"
    >
      <div class="card card-default shade">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="pull-left m-t-5 m-b-5">
                <h4 class="m-b-0">
                  Grafik Gender
                </h4>
                <p class="small hint-text">
                  Grafik Gender
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div
                v-if="data.length === 0"
                class="alert alert-danger"
                id="errorApiEl"
                role="alert"
                align="center"
              >
                <strong>Mohon maaf, data tidak tersedia! </strong>
                <br>
                Tidak dapat menampilkan grafik dengan data kosong.
              </div>
              <highcharts :options="configBar" :key="keyBar"></highcharts>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts/highcharts.js";
import HighchartsMore from "highcharts/highcharts-more.js";

HighchartsMore(Highcharts);

export default {
  name: "GenderTwitter",
  props: {
    data: {
      type: Object,
      default: function () {
        return null;
      },
    },
    tipe: String,
  },
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      configBar: {},
      keyBar: 10,
    };
  },
  methods: {
    getDataBar: function () {
      let self = this;
      this.configBar = {
        chart: {
          type: "bar",
          backgroundColor: "transparent",
        },
        title: {
          text: "",
        },
        colors: [
          '#28A745',
          '#ffc007',
          '#dc3444',
          '#7cb5ec'
        ],

        xAxis: {
          categories: this.data.data.categories,
          title: {
            text: null,
          },
        },
        yAxis: {
          min: 0,
          labels: {
            overflow: "justify",
          },
          title: {
            text: "Jumlah",
          },
        },
        tooltip: {
          formatter: function () {
            var s =
              '<small>' + this.key + '</small><br>'
              + '<span>' + this.series.name + '</span> : '
              + Highcharts.numberFormat(this.point.y, 0, ',', ',')
            return s;
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              style: {
                textOutline: false
              },
              formatter: function() {
                return Highcharts.numberFormat(this.y, 0, ',', ',');
              },
            },
            colorByPoint: true
          },
          series: {
            cursor: 'pointer',
            events: {
              click: function (event) {
                let start = "";
                let end = "";
                let params = {};

                start = moment(self.$route.query.from).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                end = moment(self.$route.query.to).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                let gender;
                if (event.point.category == "Perempuan") {
                  gender = btoa(1);
                } else if (event.point.category == "Laki-Laki") {
                  gender = btoa(-1);
                } else if (event.point.category == "Tidak Diketahui") {
                  gender = btoa(0);
                }
                params = {
                  from: start,
                  to: end,
                  gender: gender,
                };
                // console.log(params)
                self.$router.push({ path: "/posts", query: params });
              },
            },
          }
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Gender",
            data: this.data.data.series,
            showInLegend: false,
          },
        ],
      };
      this.keyBar++;
    },
  },
  created() {
    if (this.data) {
      this.getDataBar();
    }
  },
};
</script>
